import React from 'react'
import { Card } from 'react-bootstrap';
import InvestmentForm from '../investment/InvestmentForm';
import HeroImageForm from './HeroImageForm';
function HeroSection() {
  return (
    <>
    <Card className="h-100 mt-3">
      <Card.Header className="bg-light btn-reveal-trigger d-flex flex-between-center">
        <h5 className="mb-0">Hero Image</h5>
      </Card.Header>
      <Card.Body>
        <HeroImageForm />
      </Card.Body>
    </Card>
  </>
  )
}

export default HeroSection